import React from 'react'
import dayjs from 'dayjs';
import { useHistory } from 'react-router';
import useApp from '../../store/app/appContext';


function AppointmentCard({ appointment }) {
    const history = useHistory();

    const {
    appState: { user, userAccount },
  } = useApp();

  //partners can only check their own appointment details
  const shouldClickOnAppointment = userAccount.isPartner && user._id !== appointment.partnerId ? false : true;
  
  const onClickAppointment = () => {
    if (!shouldClickOnAppointment) return;
    if (userAccount.isStaff || userAccount.isRoot) {
      return history.push({pathname: '/appointments/' + appointment.appointment_id, state: {appointment: appointment} })
    }
    return history.push({pathname:'/my-appointments/' + appointment.appointment_id, state: { appointment: appointment } })
  }

  return(
      <div onClick={()=> onClickAppointment()} key={appointment.uri} className={`flex justify-between bg-gray-100 py-4 px-8 rounded-lg ${shouldClickOnAppointment ? "cursor-pointer hover:bg-violet-400 active:bg-violet-600" : ""}`}>
          <div>
              <span className="text-secondary font-extrabold">Collaborator</span>
              <p className="text-secondary">{appointment.partnerName}</p>
          </div>
          <div>
              <span className="text-secondary font-extrabold">Date</span>
              <p className="text-secondary">{dayjs(appointment.startTime).format('DD/MM/YYYY')}</p>
          </div>
          <div>
              <span className="text-secondary font-extrabold">Start</span>
              <p className="text-secondary">{dayjs(appointment.startTime).format('h')}:{dayjs(appointment.startTime).format('mm')} {dayjs(appointment.startTime).format('A')}</p>
          </div>
          <div>
              <span className="text-secondary font-extrabold">End</span>
              <p className="text-secondary">{dayjs(appointment.endTime).format('h')}:{dayjs(appointment.endTime).format('mm')} {dayjs(appointment.endTime).format('A')}</p>
          </div>
          <div>
              <span className="text-secondary font-extrabold">Status</span>
              <p className="text-secondary">{appointment.status}</p>
          </div>
      </div>
  )
}

export default AppointmentCard;
